export enum ExternalLink {
  // Stripe
  STRIPE_BASE = 'https://stripe.com',
  STRIPE_BILLING = 'https://stripe.com/docs/billing/subscriptions/backdating?dashboard-or-api=api#backdating-billing-cycle',

  // Docs
  DOCS_BASE = 'https://docs.localstack.cloud',
  DOCS_TOOLS = 'https://docs.localstack.cloud/aws/tooling/',
  DOCS_CLOUD_PODS = 'https://docs.localstack.cloud/aws/capabilities/state-management/cloud-pods/',
  DOCS_CI = 'https://docs.localstack.cloud/aws/integrations/continuous-integration/',
  DOCS_EXTENSIONS = 'https://docs.localstack.cloud/aws/tooling/extensions/',
  DOCS_DESKTOP_APP = 'https://docs.localstack.cloud/aws/developer-tools/running-localstack/localstack-desktop/',
  DOCS_DEVELOPING_EXTENSIONS = 'https://docs.localstack.cloud/aws/tooling/extensions/developing-extensions/',
  DOCS_FEATURES_UNDER_DEVELOPMENT = 'https://docs.localstack.cloud/aws/changelog/#features-under-development',
  DOCS_LAMBDA_HOT_RELOADING = 'https://docs.localstack.cloud/aws/tooling/lambda-tools/hot-reloading/',
  DOCS_SSO = 'https://docs.localstack.cloud/aws/enterprise/sso/',
  DOCS_AWS_CLI = 'https://docs.localstack.cloud/aws/integrations/aws-native-tools/aws-cli/',
  DOCS_CORE_CONFIG = 'https://docs.localstack.cloud/aws/capabilities/config/configuration/#core',
  DOCS_ADD_BADGE_TO_REPO = 'https://docs.localstack.cloud/aws/capabilities/state-management/launchpad/#adding-a-badge-to-your-repository',
  DOCS_SECURITY_LAUNCHPAD = 'https://docs.localstack.cloud/aws/capabilities/state-management/launchpad/#security-implications-of-the-launchpad',
  DOCS_FEATURE_COVERAGE = 'https://docs.localstack.cloud/aws/licensing/#service-coverage-clarification',
  DOCS_AWS_GETTING_STARTED = 'https://docs.localstack.cloud/aws/getting-started/installation/',
  DOCS_PODS_CLI = 'https://docs.localstack.cloud/aws/capabilities/state-management/cli-commands/',
  DOCS_STATE_MGMT = 'https://docs.localstack.cloud/aws/capabilities/state-management/export-import-state/',
  DOCS_STACK_INSIGHTS = 'https://docs.localstack.cloud/aws/organizations-admin/stack-insights/',
  DOCS_QUICK_START = 'https://docs.localstack.cloud/aws/getting-started/quickstart/',
  DOCS_USER_LICENSE = 'https://docs.localstack.cloud/aws/organizations-admin/managing-users-licenses/',
  DOCS_ECR_GUIDE = 'https://docs.localstack.cloud/aws/services/ecr',
  DOCS_AUTH_TOKEN = 'https://docs.localstack.cloud/aws/getting-started/auth-token/',
  DOCS_CREDENTIALS = 'https://docs.localstack.cloud/aws/capabilities/config/credentials/',
  DOCS_EPHEMERAL_INSTANCES = 'https://docs.localstack.cloud/aws/capabilities/cloud-sandbox/ephemeral-instances/',
  DOCS_SECURITY_TESTING = 'https://docs.localstack.cloud/aws/capabilities/security-testing/',
  DOCS_CHAOS_ENGINEERING = 'https://docs.localstack.cloud/aws/capabilities/chaos-engineering/',
  DOCS_SAMPLE_APPS = 'https://docs.localstack.cloud/aws/sample-apps/',

  // Legal
  LEGAL_PRIVACY_POLICY = 'https://localstack.cloud/legal/privacy-policy',
  LEGAL_TOS = 'https://localstack.cloud/legal/terms-of-service',
  LEGAL_DPA = 'https://www.localstack.cloud/legal/dpa',
  LEGAL_MSA = 'https://localstack.cloud/legal/msa',

  // Demos
  DEMO_LS = 'https://github.com/localstack/localstack-demo',
  DEMO_PET_STORE = 'https://hub.docker.com/r/localstack/ecsapi-demo-petstore',
  DEMO_FOOD_STORE = 'https://hub.docker.com/r/localstack/ecsapi-demo-foodstore',
  DEMO_THUNDRA = 'https://github.com/thundra-io/thundra-demo-localstack-java',
  DEMO_QUIZ_APP = 'https://github.com/localstack-samples/serverless-quiz-app',
  DEMO_SWAG_STORE = 'https://github.com/localstack-samples/localstack-swag-store',

  // Sample
  SAMPLE_TF_ECS_AGW = 'https://github.com/localstack-samples/sample-terraform-ecs-apigateway',

  // Contact Sales
  CONTACT_SALES = 'https://www.localstack.cloud/demo',
  CONTACT_SALES_SNOWFLAKE = 'https://www.localstack.cloud/demo?utm_source=localstack&utm_medium=webapp&utm_campaign=98424026-Snowflake%20Launch',

  // Contact Team

  CONTACT_TEAM = 'https://www.localstack.cloud/contact',

  // Console
  WEB_APP_SIGN_IN = 'https://app.localstack.cloud/sign-in',
  WEB_APP_BASE = 'https://app.localstack.cloud',
  WEB_APP_DEFAULT_ENDPOINT = 'https://localhost.localstack.cloud:4566',

  // Badges
  BADGE_LAUNCH_POD = 'https://localstack.cloud/gh/launch-pod-badge.svg',

  // Logos
  LOGO_AUTHRESS_EXTENSION = 'https://raw.githubusercontent.com/authress/localstack-extension/release/0.1/logo.png',

  // AWS
  EXTERNAL_AWS_CLI = 'https://aws.amazon.com/cli/',
  EXTERNAL_AWS_PRODUCT_LINK = 'https://aws.amazon.com/marketplace/pp/prodview-toez36gqeoa6a?sr=0-2&ref_=beagle&applicationId=AWSMPContessa',

  // Snowflake
  SNOWFLAKE_INTRODUCTION = 'https://docs.localstack.cloud/snowflake/',
  DOC_SNO_GETTING_STARTED = 'https://docs.localstack.cloud/snowflake/getting-started/',
  SNOWFLAKE_SERVICE_COVERAGE = 'https://docs.localstack.cloud/snowflake/features/',
  SNOWFLAKE_DOCS_CI = 'https://docs.localstack.cloud/snowflake/integrations/continuous-integration/',

  // Azure
  AZURE_SERVICE_COVERAGE = 'https://docs.localstack.cloud/azure/services/',
  AZURE_GETTING_STARTED = 'https://docs.localstack.cloud/azure/getting-started/',
  AZURE_INTEGRATIONS = 'https://docs.localstack.cloud/azure/integrations/',
  AZURE_SAMPLES_REPO = 'https://github.com/localstack/localstack-azure-samples',

  // Others
  EXTERNAL_GRAVATAR = 'https://en.gravatar.com/',
  EXTERNAL_BREW = 'https://brew.sh/',
  EXTERNAL_THUNDRA = 'https://thundra.io',
  EXTERNAL_LSTK_GITHUB = 'https://github.com/localstack/lstk',

  EXTENSION_HELLO_WORLD = 'https://github.com/localstack/localstack-extensions/tree/main/hello-world',

  SLACK_LANDING_PAGE = 'https://localstack.cloud/slack',
  SNOWFLAKE_SAMPLE_REPO = 'https://github.com/localstack-samples/localstack-snowflake-samples',
  AWS_SAMPLES_REPO = 'https://github.com/localstack-samples/',
  GITHUB_STUDENT_DEVELOPER_PACK = 'https://education.github.com/pack',
  LOCALSTACK_FOR_STUDENTS = 'https://www.localstack.cloud/localstack-for-students',
  MARKETING_PRICING = 'https://www.localstack.cloud/pricing',
}
